import { useState, useEffect } from "react";
import "./popad.css";

const Popad = () => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div className={`popad-overlay${closing ? " popad-overlay--out" : ""}`}>
      <div className={`popad${closing ? " popad--out" : ""}`}>

        <button className="popad-close" onClick={handleClose} aria-label="Close">
          <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>

        <div className="popad-inner">
          <h1 className="popad-title">
            The<br />Design<br />Show
          </h1>

          <p className="popad-date">May 14–16, 2026</p>
          <p className="popad-venue">Cairo Exhibition Center</p>

          <a
            href="#book"
            className="popad-btn"
            onClick={(e) => e.preventDefault()}
          >
            Book Now
          </a>

          <p className="popad-ticket">Ticket #2026-DS-001</p>
        </div>

      </div>
    </div>
  );
};

export default Popad;